import React from "react";

import { Utils } from "../../../common/utils";
import { InputWithError, TextAreaWithError } from "../../../components/formcomponents";
import { routes } from "utilities/routing/generatedRoutes";
import { HtmlEditor } from "components/ValidatedFields/HtmlEditor";

interface Props {
  initialEmailProfile: server.dto.UserEmailProfile
}

interface IState {
  emailProfile: server.dto.UserEmailProfile
  emailWarning?: string
  senderWarning?: string
  signatureWarning?: string
}

// TODO: Rewrite this to use EditTemplate
export default class EmailSettingsPanel extends React.Component<Props, IState> {
  state: IState = {
    emailProfile: this.props.initialEmailProfile,
    emailWarning: "",
    senderWarning: "",
    signatureWarning: ""
  };

  componentDidMount() {
    window.CoreApi.UserEmailProfile.GetUserEmailProfile()
      .then(profile => { this.setState({ emailProfile: profile.data }); });
  }

  onEmailChanged = (_, { value }) => {
    const error = this.validateEmail(value);

    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        email: value
      },
      emailWarning: error
    });
  };

  validateEmail = (email: string): string => {
    if (email.trim() === "") {
      return RESX.Advancing.EmailRequired;
    }

    const parsed = Utils.getValidEmails(email);

    if (parsed.length === 0) {
      return RESX.GeneralLabels.EmailIsInvalid;
    }

    if (parsed.length > 1) {
      return RESX.Email.OnlyOneEmail;
    }

    return "";
  };

  validateSender = (sender: string): string => {
    if (sender.trim() === "") {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return "";
  };

  onSenderChanged = (_, { value }) => {
    const errorMessage = this.validateSender(value);

    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        displayName: value
      },
      senderWarning: errorMessage
    });
  };

  onSignatureChanged = (signature: string) => {
    const error = this.validateSignature(signature);

    this.setState({
      signatureWarning: error,
      emailProfile: {
        ...this.state.emailProfile,
        signature
      }
    });
  };

  validateSignature = (signature): string => {
    if (signature.trim() === "") {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return "";
  };

  onDefaultBccBlur = (ev) => {
    const validatedBcc = Utils.processManualRecipientsString(ev.target.value);

    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        defaultBcc: validatedBcc
      }
    });
  };

  onDefaultBccChange = (_, { value }) => {
    this.setState({
      emailProfile: {
        ...this.state.emailProfile,
        defaultBcc: value
      }
    });
  };

  saveEmailSetting = () => {
    let canSave = true;

    if (this.validateEmail(this.state.emailProfile.email)) {
      canSave = false;
    }

    if (this.validateSender(this.state.emailProfile.displayName)) {
      canSave = false;
    }

    if (this.validateSignature(this.state.emailProfile.signature)) {
      canSave = false;
    }

    if (canSave) {
      this.performSave(this.state.emailProfile);
    }
  };

  performSave = async (emailProfile: server.dto.UserEmailProfile) => {
    await window.CoreApi.UserEmailProfile.UpdateEmailPreferences(emailProfile);
    window.location.href = routes.personal_SettingMenu().absolute;
  }

  public render(): JSX.Element {
    return <>
      <table className="s1_table clean rowspace">
        <tbody>
          <tr>
            <td>{RESX.GeneralLabels.Email}</td>
            <td>
              <InputWithError
                fluid
                maxLength={100}
                errorMessage={this.state.emailWarning}
                onChange={this.onEmailChanged}
                value={this.state.emailProfile.email}
              />
            </td>
          </tr>
          {site.currentEnvironment.type !== "external" && <>
            <tr>
              <td>{RESX.PersonalSettings.Sender}</td>
              <td>
                <InputWithError
                  maxLength={80}
                  fluid
                  errorMessage={this.state.senderWarning}
                  onChange={this.onSenderChanged}
                  value={this.state.emailProfile.displayName}
                />
              </td>
            </tr>
            <tr>
              <td>{RESX.SoUser.Signature}</td>
              <td>
                <div className={this.state.signatureWarning ? "s1_warningborder" : null}>
                  <HtmlEditor
                    toolbar="Normal"
                    maxContentLength={serverReference.constants.emailMessage.maxBodyLength}
                    onChange={this.onSignatureChanged}
                    content={this.state.emailProfile.signature}
                  />
                </div>
                <div className="s1_warning">
                  {this.state.signatureWarning}
                </div>
              </td>
            </tr>
            <tr>
              <td>{RESX.PersonalSettings.DefaultRecipientsInBccField}</td>
              <td>
                <TextAreaWithError
                  maxLength={1000}
                  value={this.state.emailProfile.defaultBcc}
                  onChange={this.onDefaultBccChange}
                  onBlur={this.onDefaultBccBlur}
                />
              </td>
            </tr>
          </>}
        </tbody>
      </table>
      <div>
        <div className="flex justify-end margin-top-bigger">
          <button
            className="button-new primary"
            type="button"
            id="btnSave"
            onClick={this.saveEmailSetting}>
            {RESX.Buttons.btnSave}
          </button>
        </div>
      </div>
    </>;
  }
}
